import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'config/Routes';
import i18next from 'i18next';
import ListLayout from 'components/common/ListLayout';
import { Context } from 'states/Store';
import {
  getFilteredContextInstances,
} from 'services/edge/ContexteService';
import { ContextAddButton } from 'components/common/datatable/DataTableButtons';
import ContextDataTable from './ContextDataTable';
import Filters from './Filters';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from '../../services/common/RolesUtils';
import { FormProvider, useForm } from 'react-hook-form';

const ContextComp = ({ active }) => {
  const [state, dispatch] = useContext(Context);
  const contextInstances = state.contextInstances;
  const [filteredContextInstance, setFilteredContextInstance] = useState(
    contextInstances
  );
  const [isLoading, setIsLoading] = useState(true);

  const formMethods = useForm({
    mode: 'onChange',
    delayError: 500,
    defaultValues: {
      modelId: '',
      reference: null,
      startDate: null,
      endDate: null,
      attributes: null,
    },
  });
  const { getValues } = formMethods;

  let history = useHistory();
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const fetchContextInstances = useCallback(async () => {
    const page = state.context_pagination.page;
    const limit = state.context_pagination.rowPerPage;
    const offset = page * limit;
    await getFilteredContextInstances(
      state.account.id,
      active,
      limit,
      offset,
      getValues(),
      dispatch
    );
    setIsLoading(false);
  }, [
    state.account,
    active,
    dispatch,
    state.context_pagination.rowPerPage,
    state.context_pagination.page,
    getValues,
  ]);

  const createContext = async () => {
    history.push(ROUTES.ADD_CONTEXT);
  };

  useEffect(() => {
    setFilteredContextInstance(contextInstances);
  }, [contextInstances]);

  useEffect(() => {
    fetchContextInstances();
  }, [state.context_pagination.rowPerPage, state.context_pagination.page, fetchContextInstances]);

  return (
    <ListLayout
      count={
        filteredContextInstance ? filteredContextInstance.totalElements : ''
      }
      totalCount={
        filteredContextInstance ? filteredContextInstance.globalCount : ''
      }
      icon={'drawer/context_list'}
      title={i18next.t(`menu.context`)}
      isLoading={isLoading}
      addingComponent={
        active ? (
          <ContextAddButton
            onClickHandler={createContext}
            disabled={
              !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_CREATE_CONTEXT)
            }
          />
        ) : (
          <></>
        )
      }
      filterField={
        <FormProvider {...formMethods}>
          <Filters onSearch={fetchContextInstances} />
        </FormProvider>
      }
      paginationType={'CONTEXT_PAGINATION'}
    >
      {filteredContextInstance &&
      filteredContextInstance.content &&
      filteredContextInstance.content.length ? (
        <ContextDataTable
          contextInstanceList={filteredContextInstance}
          fetchContextInstances={fetchContextInstances}
        />
      ) : (
        <></>
      )}
    </ListLayout>
  );
};

export default ContextComp;
